module.exports = "fragment CalendarDateFragment on CalendarDate {\n  day\n  month\n  year\n}\n"